/**
 * Patches ResizeObserver to prevent the benign
 * "ResizeObserver loop completed with undelivered notifications" browser error
 * that Nivo's Responsive* chart components trigger.
 *
 * The error occurs because Nivo's ResizeObserver callback triggers a synchronous
 * React state update (re-render), which causes layout changes that the observer
 * detects within the same observation loop — exceeding the browser's loop limit.
 *
 * By deferring the callback to the next animation frame we break out of the
 * synchronous loop, so the browser never detects a loop violation.
 *
 * @see https://github.com/WICG/resize-observer/issues/38
 */

export {};

const OriginalResizeObserver = window.ResizeObserver;

window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};
